<template>
  <div id="reset-password">
    <div class="container">
      <transition name="fade">
        <comp-message
          v-if="showMessage"
          :msgText="messageText"
          :msgSuccess="!messageIsErr"
          :msgError="messageIsErr"
          @closeMsg="showMessage = false"
        />
      </transition>

      <div class="form-group">
        <div class="form-container">
          <label class="label" for="email"
            >Password reset link will be sent to</label
          >
          <input
            type="email"
            name=""
            id="email"
            placeholder="Your Email Address"
            v-model.trim="userId"
          />
        </div>
      </div>

      <div class="button-group">
        <div class="button-container">
          <div class="button" @click="goBack">Cancel</div>
        </div>
        <div class="button-container">
          <div class="button" @click="performResetPassword">Reset</div>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common'
import UserService from '@/services/user-service'
import CompMessage from '@/components/CompMessage'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'ResetPassword',
  mixins: [common],
  components: {
    CompMessage,
    CompLoading
  },
  data() {
    return {
      pageTitle: 'Reset Password',

      isLoading: false,

      showMessage: false,
      messageText: '',
      messageIsErr: false,

      userId: ''
    }
  },
  created() {
    this.$parent.setNav(false)
    this.$parent.setHeader(this.pageTitle)
    this.$parent.headerBack = true
    this.$parent.setBottomTab(false)
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    }
  },
  methods: {
    performResetPassword() {
      const userEmail = this.userId
      if (userEmail) {
        this.isLoading = true

        UserService.resetPassword(userEmail).then(
          ({ resultCode, resultMsg }) => {
            this.showInfoMessage(resultMsg, resultCode !== 0)
          }
        )
      }
    },
    showInfoMessage(message, isError) {
      this.isLoading = false

      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/acc.scss" scoped></style>
